var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "rotate-90 scale-0 transition-all dark:-rotate-0 dark:scale-100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20v2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4.93 4.93 1.41 1.41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.66 17.66 1.41 1.41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12h2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m6.34 17.66-1.41 1.41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m19.07 4.93-1.41 1.41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/darkMode.0ba3aa3067ea4bf7995c5e3a22f9dee6.svg";
export { ForwardRef as ReactComponent };